import { request3 } from '../../utils/request'
import { urlStringify } from '../../utils/index'

export const publishhomepage = option => {
  const urls = urlStringify(option)
  return request3('v1/wxappportal/publishhomepage' + urls, {}, true, false) // 设为主页
}

export const publishportalpage = option => {
  const urls = urlStringify(option)
  return request3('v1/wxappportal/publishportalpage' + urls, {}, true, false) // 发布页面
}

export const getwxacode = option => {
  const urls = urlStringify(option)
  return request3('v1/wxappportal/getwxacode' + urls, {}, true, false) // 主页 预览 获取小程序码
}

export const deleteportalpage = option => {
  const urls = urlStringify(option)
  return request3('v1/wxappportal/deleteportalpage' + urls, {}, true, false) // 删除页面
}

export const getportalpages = option =>
  request3('v1/wxappportal/getportalpages', option, true, false) // 删除页面

export const getportaltemplates = option =>
  request3('v1/wxappportal/getportaltemplates', option, true, false) // 获取主页模版列表

export const getwxapppage = option => {
  const urls = urlStringify(option)
  return request3('v1/wxapppage/getwxapppage' + urls, {}, true, false) // 设为主页
}

export const addportalpage = option =>
  request3('v1/wxappportal/addportalpage', option, true, false) // 新增主页模版

export const updateportalpage = option =>
  request3('v1/wxappportal/updateportalpage', option, true, false) // 修改主页模版

export default {
  getportalpages: option =>
    request3('v1/wxappportal/getportalpages', option, true, false), // 页面list
  deleteportalpage: option => {
    const urls = urlStringify(option)
    return request3('v1/wxappportal/deleteportalpage' + urls, {}, true, false) // 删除页面
  },
  publishhomepage: option => {
    const urls = urlStringify(option)
    return request3('v1/wxappportal/publishhomepage' + urls, {}, true, false) // 设为主页
  },
  publishportalpage: option => {
    const urls = urlStringify(option)
    return request3('v1/wxappportal/publishportalpage' + urls, {}, true, false) // 发布页面
  },
  getportalpage: option => {
    const urls = urlStringify(option)
    return request3('v1/wxappportal/getportalpage' + urls, {}, true, false) // 获取单个页面
  },
  addportalpage: option =>
    request3('v1/wxappportal/addportalpage', option, true, false), // 新增主页模版
  updateportalpage: option =>
    request3('v1/wxappportal/updateportalpage', option, true, false), // 修改主页模版

  gettagscanscenes: option =>
    request3('/v1/tagscanscene/gettagscanscenes', option, true, false), // 页面list
  gettagscanscene: option => {
    const urls = urlStringify(option)
    return request3('/v1/tagscanscene/gettagscanscene' + urls, {}, true, false) // 获取单个页面
  },
  addtagscanscene: option =>
    request3('v1/tagscanscene/addtagscanscene', option, true, false), // 新增主页模版
  updatetagscanscene: option =>
    request3('v1/tagscanscene/updatetagscanscene', option, true, false), // 修改主页模版
  settagscansceneproducts: option =>
    request3('v1/tagscanscene/settagscansceneproducts', option, true, false) // 新增主页模版
}
